import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button, Input, Select, Checkbox, Slider } from '@kaleyra/emmy';

import { ContactsType, ContactsFormNameType } from '../../../../../interface';

import View from '../../../../../assets/View';
import Cross from '../../../../../assets/Cross';
import Plus from '../../../../../assets/Plus';

import Styles from './index.module.scss';

export type MapStateType = {
	contacts: ContactsType;
};

export type DispatchPropsType = {
	onChange: (fields: { name: ContactsFormNameType; value: any }) => void;
	loadInitObject: (contacts: Partial<ContactsType>) => void;
	onClose: () => void;
};

const EmptyObject = {
	label: '',
	value: '',
};

const ContactsForm: React.FC<MapStateType & DispatchPropsType> = ({
	contacts,
	onChange,
	onClose,
	loadInitObject,
}) => {
	const { t } = useTranslation();

	React.useEffect(() => {
		if (!contacts?.customFields?.length) {
			loadInitObject({
				customFields: [EmptyObject],
			});
		}
	}, []);

	const getFooter = (): React.ReactNode => {
		return (
			<div className={Styles.footerContainer}>
				<Button type="tertiary" onClick={onClose}>
					{t('mainCancel')}
				</Button>
				<Button type="primary" onClick={onClose}>
					{t('mainSave')}
				</Button>
			</div>
		);
	};

	const localOnChange = (name: ContactsFormNameType, isCustom?: boolean) => (
		value: any
	) => {
		onChange({
			name,
			value: isCustom
				? (value as React.ChangeEvent<HTMLInputElement>).target.value
				: value,
		});
	};

	const addNew = () => {
		localOnChange('customFields')([...contacts?.customFields, EmptyObject]);
	};

	const removeFields = (index: number) => {
		localOnChange('customFields')(contacts?.customFields.splice(index, 1));
	};

	const getBody = (): React.ReactNode => {
		return (
			<div className={Styles.formContainer}>
				<Input
					value={contacts?.name}
					placeholder={t('mainFullNamePlaceholder')}
					label={t('mainFullName')}
					onChange={localOnChange('name', true)}
				/>
				{/* replace with mobile no component */}
				<Input
					value={contacts?.number}
					placeholder={t('mainMobileNumber')}
					label={t('mainMobileNumber')}
					onChange={localOnChange('number', true)}
				/>
				<Input
					value={contacts?.email}
					placeholder={t('mainEmailAddressPlaceholder')}
					label={t('mainEmailAddress')}
					onChange={localOnChange('number', true)}
				/>
				<Input
					value={contacts?.city}
					placeholder={t('mainCityPlaceHolder')}
					label={t('mainCity')}
					onChange={localOnChange('number', true)}
				/>
				<Input
					value={contacts?.state}
					placeholder={t('mainStatePlaceholder')}
					label={t('mainState')}
					onChange={localOnChange('number', true)}
				/>
				{/* replace with multiselect */}
				<Select
					defaultValue={0}
					value={contacts?.tags}
					placeholder={t('selectTagsPlaceholder')}
					label={t('selectTags')}
					onChange={localOnChange('number', true)}
				/>
				<div>
					<div className={cn('rowK', Styles.customHeader)}>
						<p>{t('customFields')}</p>
						<button>
							<View height={24} width={24} color={'#1676EE'} />
							{t('viewAllFields')}
						</button>
					</div>
					{contacts?.customFields?.map((item, index) => (
						<div className={cn('rowK', Styles.customFields)}>
							<Select
								defaultValue={0}
								value={item.label}
								placeholder={t('customField')}
								label={t('customField', { index: index + 1 })}
							/>
							<Input
								placeholder={t('value')}
								label={t('value')}
								value={item.value as string}
							/>
							<button
								disabled={index === 0}
								onClick={() => removeFields(index)}
							>
								<Cross
									height={24}
									width={24}
									color={'#C3CDD9'}
								/>
							</button>
						</div>
					))}
					<button className={Styles.addNew} onClick={addNew}>
						<Plus height={24} width={24} color={'#1676EE'} />
						{t('addNewField')}
					</button>
				</div>
				{/* add click event */}
				<Checkbox
					checked={Boolean(contacts?.blacklisted)}
					label={t('blacklist')}					
				/>
			</div>
		);
	};

	return (
		<Slider
			footer={getFooter()}
			visibility={true}
			containerId={'root-modal'}
			onClose={onClose}
			title={t('addContact')}
		>
			{getBody()}
		</Slider>
	);
};

export default ContactsForm;
